<script lang="ts" setup>
const documentId = inject("documentId") as any;

const documentHeadersStore = useDocumentHeadersStore(documentId);
const { documentHeaders } = storeToRefs(documentHeadersStore);
</script>

<template>
  <pre></pre>
  <div
    v-if="documentHeaders && documentHeaders.length > 0"
    class="flex flex-row"
  >
    <DocumentParagraphsParagraph
      v-for="header in documentHeaders"
      :key="header.id"
      :paragraph="header"
      :enable-comments="false"
      class="header-paragraph grow"
    />
  </div>
</template>

<style>
.header-paragraph span {
  @apply text-medium-default;
}
</style>
